import { render, staticRenderFns } from "./CreateEditTemplate.vue?vue&type=template&id=fc106a04"
import script from "./CreateEditTemplate.vue?vue&type=script&lang=js"
export * from "./CreateEditTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateEditTemplate.vue?vue&type=style&index=0&id=fc106a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports